import { FormControlLabel, Switch } from '@mui/material'
import React from 'react'

import AiUsageHelper from './ai-usage-helper'

type Props = {
  useCategories: boolean
  onChange: (value: boolean) => void
}

const UseCategoriesToggle: React.FC<Props> = ({ useCategories, onChange }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked),
    [onChange],
  )

  return (
    <div>
      <FormControlLabel
        id="use-categories-toggle"
        control={<Switch checked={!!useCategories} onChange={handleChange} />}
        label="AI enhanced answer categorization"
      />
      <AiUsageHelper text="We use AI to choose the category." />
    </div>
  )
}

export default UseCategoriesToggle
